export const DocumentUpload = "DocumentUpload/";
export const SupportingDocumentsFileUpload = DocumentUpload + 'SupportingDocumentsFileUpload';
export const GetDocumentTypesForSection = DocumentUpload + 'GetDocumentTypesForSection';
export const GetDocumentsUploaded = DocumentUpload + 'GetDocumentsUploaded';
export const DocumentUploadFileUpload = DocumentUpload + 'DocumentUploadFileUpload';
export const SelectDocumentsForDownload = DocumentUpload + 'SelectDocumentsForDownload';
export const RemoveSelectedDocumentsForDownload = DocumentUpload + 'RemoveSelectedDocumentsForDownload';